import React from "react";
import routeGuard from "src/HOC/routeGuard";
import WindTunnelTestNalList from "src/components/TestAnalysis/WindTunnel";
import { RESOURCE_TYPE } from "src/constant/common";

const WindTunnelTestNal = () => {
  return (
    <WindTunnelTestNalList />
  );
};

export default routeGuard(WindTunnelTestNal, RESOURCE_TYPE.TEST_ANALYSIS);
